export class Paper {
  constructor ({ title = '', type = 'conference', year = 0 } = {}) {
    this.title = title
    this.type = type
    this.year = year
  }
}
